export default __webpack_public_path__ + "static/media/1985.1641b9aa.png";